/**
 * Noon-UTC anchor so the calendar date survives every display timezone (same trick as the
 * subscription modal). Shared by the create modal, the milestone modal and the details form.
 */
export function toWireDate(iso) {
    return iso ? `${iso}T12:00:00Z` : null;
}
